import type {
  VehicleResolveRequest,
  VehicleResolveResponse,
  TireAnalysisResponse,
  Inspection,
  TirePosition,
} from '../types';

// Use real ML backend
// Development: http://localhost:8000/api
// Production: /api (proxied by Nginx)
const API_BASE = import.meta.env.DEV ? 'http://localhost:8000/api' : '/api';

export const api = {
  async resolveVehicle(data: VehicleResolveRequest): Promise<VehicleResolveResponse> {
    const response = await fetch(`${API_BASE}/vehicle/resolve`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error('Failed to resolve vehicle');
    return response.json();
  },

  /**
   * Analyze tire using ML backend
   * Sends actual image file to Python Flask server with OpenCV + TensorFlow
   */
  async analyzeTireWithML(imageFile: File, position: TirePosition): Promise<TireAnalysisResponse> {
    // Create FormData to send image file
    const formData = new FormData();
    formData.append('image', imageFile);
    formData.append('position', position);

    console.log(`🤖 Sending tire image to ML backend for analysis...`);
    console.log(`📊 Position: ${position}, File: ${imageFile.name}`);

    const response = await fetch(`${API_BASE}/analysis/tire`, {
      method: 'POST',
      body: formData, // Send as multipart/form-data
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`ML Analysis failed: ${error}`);
    }

    const result = await response.json();
    console.log(`✅ ML Analysis complete:`, result);
    return result;
  },

  async getInspections(): Promise<Inspection[]> {
    const response = await fetch(`${API_BASE}/inspections`);
    if (!response.ok) throw new Error('Failed to fetch inspections');
    return response.json();
  },

  async getInspection(id: string): Promise<Inspection> {
    const response = await fetch(`${API_BASE}/inspections/${id}`);
    if (!response.ok) throw new Error('Failed to fetch inspection');
    return response.json();
  },

  async saveInspection(inspection: Inspection): Promise<Inspection> {
    const response = await fetch(`${API_BASE}/inspections`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(inspection),
    });
    if (!response.ok) throw new Error('Failed to save inspection');
    return response.json();
  },
};
